import * as Phaser from "phaser"
import { GAME_WIDTH } from "../../data/constants"
import type { EnemyData, GameSprite } from "../../types"
import {
  type EnemyState,
  StatefulEnemyRuntime,
  clampEnemyY,
} from "../enemy-system"

export class HarvesterEnemy extends StatefulEnemyRuntime<"active"> {
  public constructor(sprite: GameSprite, enemyData: EnemyData) {
    const states: EnemyState<"active">[] = [
      {
        name: "active",
        behaviorState: "flying",
        animationState: "flying",
        update: (context) => {
          const { sprite, enemyData, delta, scrollCompensation } = context
          const spec = context.enemyDef?.movementSpec
          if (spec?.action !== "harvester-patrol") return null

          const minX = 120
          if (sprite.x < minX) {
            sprite.x += (minX - sprite.x) * 0.1 * (delta / 16.6)
            if (enemyData.vx < 0) enemyData.vx *= 0.5
          }

          const homeX = enemyData.homeX ?? GAME_WIDTH * 0.7
          const homeY = enemyData.homeY ?? sprite.y

          const hoverX =
            Math.sin(context.time / 180) * 50 + Math.sin(context.time / 60) * 15
          const hoverY =
            Math.cos(context.time / 150) * 40 + Math.sin(context.time / 90) * 20

          const targetX = homeX + hoverX
          const targetY = clampEnemyY(
            homeY + hoverY + (context.playerY - homeY) * 0.05,
          )

          const dx = targetX - sprite.x
          enemyData.vx = Phaser.Math.Linear(
            enemyData.vx,
            dx * 0.04 + scrollCompensation,
            0.08 * (delta / 16.6),
          )

          const trackFactor =
            1 - (1 - 0.12) ** ((delta / 16.6) * spec.trackSpeed)
          sprite.y = Phaser.Math.Linear(sprite.y, targetY, trackFactor)
          return null
        },
      },
    ]

    super(sprite, enemyData, "active", states)
  }
}
